import {
  DAYS_PER_WEEK,
  MAX_PREGNANCY_WEEKS,
  PREGNANCY_DURATION_DAYS,
} from "../constants/main";

export const formatDate = (date, options = {}) => {
  if (!date || isNaN(date.getTime())) {
    return "";
  }

  const {
    separator = ".",
    includeWeekday = false,
    // eslint-disable-next-line no-unused-vars
    format = "YYYY.MM.DD",
  } = options;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  let formatted = `${year}${separator}${month}${separator}${day}`;

  if (includeWeekday) {
    const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
    const weekday = weekdays[date.getDay()];
    formatted += ` (${weekday})`;
  }

  return formatted;
};

export const calculatePregnancyInfo = (babyBirth, showErrorToast = null) => {
  const getDefaultInfo = () => ({
    week: 0,
    day: 0,
    remainingDays: PREGNANCY_DURATION_DAYS,
    dueDate: new Date(),
    isPostpartum: false,
    daysSinceBirth: 0,
  });

  if (!babyBirth) {
    return getDefaultInfo();
  }

  const today = new Date();
  const dueDate = new Date(babyBirth);

  // 1. 기본 날짜 유효성 검사
  if (isNaN(dueDate.getTime())) {
    return getDefaultInfo();
  }

  // 2. 날짜 범위 검증 (좁은 범위)
  const currentYear = today.getFullYear();
  const dueDateYear = dueDate.getFullYear();

  if (dueDateYear < currentYear - 1 || dueDateYear > currentYear + 1) {
    return getDefaultInfo();
  }

  // 3. 현실적인 임신 기간 검증
  const sixMonthsAgo = new Date(today);
  sixMonthsAgo.setMonth(today.getMonth() - 6);
  const tenMonthsLater = new Date(today);
  tenMonthsLater.setMonth(today.getMonth() + 10);

  if (dueDate < sixMonthsAgo || dueDate > tenMonthsLater) {
    return getDefaultInfo();
  }

  // 4. 임신 기간 계산 및 검증
  const pregnancyStartDate = new Date(dueDate);
  pregnancyStartDate.setDate(
    pregnancyStartDate.getDate() - PREGNANCY_DURATION_DAYS
  );

  const daysSinceConception = Math.floor(
    (today - pregnancyStartDate) / (1000 * 60 * 60 * 24)
  );

  // 5. 정상적인 계산 진행
  const remainingDays = Math.ceil(
    (dueDate - today) / (1000 * 60 * 60 * 24)
  );
  const isPostpartum = remainingDays < 0;
  const daysSinceBirth = isPostpartum ? Math.abs(remainingDays) : 0;
  const weeksSinceBirth = isPostpartum
    ? Math.floor(daysSinceBirth / 7) + 1
    : 0;

  let week, day;

  if (daysSinceConception < 0) {
    week = 0;
    day = 0;
  } else if (isPostpartum) {
    week = MAX_PREGNANCY_WEEKS;
    day = DAYS_PER_WEEK;
  } else {
    week = Math.floor(daysSinceConception / DAYS_PER_WEEK);
    week = Math.max(0, Math.min(week, MAX_PREGNANCY_WEEKS));
    day = daysSinceConception % DAYS_PER_WEEK;
  }

  return {
    week,
    day,
    remainingDays: Math.max(0, remainingDays),
    dueDate,
    isPostpartum,
    daysSinceBirth,
    weeksSinceBirth,
  };
}; 